import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormSection from '../formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import { handleValidateObj } from 'constants/objValues/objvalues';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Inventory from 'components/sales/inventory/inventory';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import * as moment from 'moment';
import Loader from 'components/sales/Loader/loader';
import Regex from "../../../../services/utils/regex/Regex";

const ThreePoc = ({
  data,
  handleValue,
  getTag,
  imageUploadUrl,
  getTagById,
  prefilledData,
  oldPocData
}) => {
 
  const [inputList, setInputList] = useState([]);
  const [duration, setDuration] = useState([{id:"yearly",name:"Yearly"}]);
  // const [duration, setDuration] = useState([{id:"quarterly",name:"Quarterly"},{id:"halfYearly",name:"Half Yearly"},{id:"yearly",name:"Yearly"}]);

  const [payData, setPayData] = useState();
  const [month, setMonth] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [contract_length, setContractLength] = useState(1);
  const [subscription_amount, setAmount] = useState(0);
  const [isEditData, setIsEditData] = useState(0);
  
  const [increament, setIncreamentData] = useState();
  const [pocData, setPocData] = useState([{poc_name:"",poc_designation:"",email_id:"",contact_number:""},{poc_name:"",poc_designation:"",email_id:"",contact_number:""},{poc_name:"",poc_designation:"",email_id:"",contact_number:""}]);
  const [prefilledList, setPrefilledListList] = useState([]);

  // console.log("datadatadata", data)
  useEffect(()=>{
    if (
      oldPocData !== undefined &&
      oldPocData !== null &&
      oldPocData !== ''&&
      oldPocData.length > 0
        ) {
          const mappedPocData = oldPocData.map(item => ({
            poc_name: item.name || "",
            poc_designation: item.designation || "",
            email_id: item.email || "",
            contact_number: item.contact_no ? item.contact_no.toString() : ""
          }));
    
          setPocData(mappedPocData);
        }
  },[oldPocData]);
  // useEffect(() => {
  //   if (
  //     prefilledData?.increment_type !== undefined &&
  //     prefilledData?.increment_type !== null &&
  //     prefilledData?.increment_type !== ''
  //   ) {
  //     const {
  //       increment_type,
  //       duration,
  //       increament_amount,
  //       inc
  //     } = prefilledData;

  //     setIncreamentData({
  //       ...increament,
  //       increament_type: increment_type,
  //       increment_value: (increment_type == 'flat')
  //       ? 'Flat Value' 
  //       : increment_type == 'percentage'
  //       ? 'Percentage'
  //       : 'Non-Uniform',
  //       duration: duration,
  //       duration_value: (duration == 'quarterly')
  //       ? 'Quarterly'
  //       : (duration == 'halfYearly')
  //       ? 'Half Yearly'
  //       : 'Yearly',
  //       increament_amount: increament_amount
  //     });
  //     setPrefilledListList(inc);
  //     setIsEditData(1);
  //   }
  //   if (contract_length == undefined) {
  //     setContractLength(data?.commercialData?.contract_length);
  //   }
  // }, [prefilledData]);
  
  const handleDateChange1 = (date, dateString) => {
    const selectedDate = dateString;
    // setInputList({
    //   ...inputList,
    //   adv_payment_date: selectedDate,
    // });
    // const list = [...inputList];
    //     list[index][name] = value;
    //     setInputList(list);
    
  };


    const handleInputChange = (index,name,val)=>{
      const list = [...pocData];
      list[index][name] = val ?? 0;
      setPocData(list);
    };

   
    const handleFormData = () => {
     
      handleValue(pocData);
    };
  
  useEffect(() => {
    handleFormData();
  }, [pocData]);


  useEffect(() => {
    setContractLength(data?.commercialData?.contract_length);
    setAmount(data?.commercialData?.subscription_amount);
    if(data?.commercialData?.payment_term_type == 3){
      setMonth(3); //quarter
    }else if(data?.commercialData?.payment_term_type == 4){
      setMonth(6); // half
    }
    else if(data?.commercialData?.payment_term_type == 5){
      setMonth(12); // 1 year
    }
    else{
      setMonth(1); // month
    }
    
  },[]);

  


  return (
    <Fragment>
      
      <FormSection title={localization.pocDetails}>
        <div className="row">
        <Loader isLoading={isLoading} />
        {pocData.map((item, index) => (
          <>
          <div className='col-md-12 mb-3'><strong>POC {index+1}</strong></div>
          <div className="col-md-3">
          <ConstantInput
                label={`Poc Name`}
                required={parseInt(data?.leadSubType) !== 6}
                isStarRequired={data?.commercialData?.solution_type == 3 && index == 2 ? false : true}
                errorMsg={localization.requiredPocName}
                handleChange={(val) => handleInputChange(index, 'poc_name', val)}
                value={item?.poc_name}
              />
              
          </div>
          <div className="col-md-3">
          <ConstantInput
                label={`Designation`}
                required={parseInt(data?.leadSubType) !== 6}
                isStarRequired={data?.commercialData?.solution_type == 3 && index == 2 ? false : true}
                errorMsg={localization.requiredPocDesig}
                handleChange={(val) => handleInputChange(index, 'poc_designation', val)}
                value={item?.poc_designation}
              />
              
          </div>
          <div className="col-md-3">
          <ConstantInput
                label={`Email Id`}
                
                handleChange={(val) => handleInputChange(index, 'email_id', val)}
                value={item?.email_id}
              />
              
          </div>
          <div className="col-md-3">
          <ConstantInput
                label={`Contact Number`}
                regex={Regex.phoneNumber.test(item?.contact_number)}
                errorMsg={localization.requiredPhonenumber}
                maxLength={10}
                minLength={10}
                className="countrycode"
                isPrefix
                prefixText={'+91'}
                type="number"
                required={parseInt(data?.leadSubType) !== 6}
                isStarRequired={data?.commercialData?.solution_type == 3 && index == 2 ? false : true}
                tenDigitsValidation={true}
                handleChange={(val) => handleInputChange(index, 'contact_number', val)}
                value={item?.contact_number}
              />
              
          </div>
          <hr/>
          </>
        ))}

        </div>
       <br/>
      </FormSection>
      
    </Fragment>
  );
};
ThreePoc.propTypes = {
  data: PropTypes.any,
  handleValue: PropTypes.func,
};
export default ThreePoc;
